// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3inVm","selected":"Chip_selected__2gSRc"};